// https://github.com/PNKBizz/vue-mutation-observer
import Vue from 'vue';

type ConfigType = {
  characterData: boolean,
  characterDataOldValue: boolean,
  attributes: boolean,
  attributeOldValue: boolean,
  childList: boolean,
  subtree: boolean,
};

const config = {
  attributes: true,
  attributeOldValue: true,
  childList: true,
  characterData: true,
  characterDataOldValue: true,
} as ConfigType;

export default {
  install() {
    Vue.directive('mutation-observer', {
      bind(el, binding, vnode) {
        const { value } = binding;
        if (!value) {
          Vue.$log.error('v-mutation-observer: "Please set callback or config object."');
          return;
        }
        const cb = (typeof value === 'function' && value) || value.callback;
        (el as any).$mutationObserver = new MutationObserver(cb);
      },
      inserted(el, binding) {
        const { value, modifiers, arg } = binding;
        let currentConfig = {};
        const keys = Object.keys(modifiers);
        keys.forEach((modifier) => {
          switch (modifier) {
            case 'characterData':
              currentConfig = Object.assign(
                currentConfig,
                {
                  characterData: true,
                  characterDataOldValue: true,
                },
              );
              break;
            case 'attributes':
              currentConfig = Object.assign(
                currentConfig,
                {
                  attributes: true,
                  attributeOldValue: true,
                },
              );
              break;
            case 'childList':
              currentConfig = Object.assign(
                currentConfig,
                { childList: true },
              );
              break;
            default:
              Vue.$log.warning(`vue-mutation-observer: "Unknown modifier: ${modifier}."`);
          }
        });
        if (value.config) {
          currentConfig = Object.assign(currentConfig, value.config);
        }
        const finalConfig: ConfigType = (Object.keys(currentConfig).length > 0 && currentConfig) || config as any;
        finalConfig.subtree = !!arg && arg === 'subtree';
        try {
          (el as any).$mutationObserver.observe(el, finalConfig);
        } catch (err) {
          Vue.$log.error(`v-mutation-observer: "${err}."`);
        }
      },
    });
  },

};
